<template>
  <div id="MyCalendar">
    <div id="scrollBody">
      <van-list
        v-model="listLoading"
        :finished="finished"
        finished-text="没有更多数据了"
        @load="requestList"
        v-bind:callback="requestList"
        v-if="academicCalendar.length !== 0"
      >
        <ul class="scrollList">
          <li v-for="(item,i) in academicCalendar" :key="i">
            <div class="box-body van-hairline--bottom">
              <h3>{{item.Theme}}</h3>
              <div>
                <p>{{item.Content}}</p>
                <p style="clear:both"></p>
              </div>
            </div>
            <div class="box-footer">
              <div class="fl"></div>
              <div class="fr">
                <span class="compose">{{item.CalendarDate}}</span>
              </div>
              <div style="clear:both"></div>
            </div>
          </li>
        </ul>
      </van-list>
      
      <div v-else class="no-data-box">
        <img class="no-data-img" :src="noDataImg" />
        <span class="no-data-text">暂无日程</span>
      </div>
    </div>
  </div>
</template>

<script>
const noDataImg = require('@/assets/wisdomOffice/no-data.png');
export default {
  data() {
    return {
      page: 1,
      pageSize: 10,
      totalPages: 1,
      academicCalendar: [],
      listLoading: false,
      finished: false,
      noDataImg: noDataImg
    };
  },
  components: {},
  created: function() {
    // 加载数据列表
    this.requestList();
  },
  mounted: function() {},
  methods: {
    async requestList() {
      if (this.page > this.totalPages) {
        this.listLoading = true;
      } else {
        let params = {
          searchTxt: "",
          pageIndex: this.page,
          pageSize: this.pageSize
        };
        // xy.http.get(xy.string.format("{0}/api/Calendar/GetPage", xy.subMenuServiceUrl), {
        this.xy.loading();
        let res = await this.xyapi.get(
          this.$store.state.apiPath + "/api/Calendar/GetPage",
          params
        );
        this.xy.unloading();

        if (res&&!res.success) {
          this.xy.msgInfo(res && res.msg ? res.msg : "获取失败");
        } else {
          if (res&&res.data&&res.data.data&&res.data.data.length > 0) {
            this.totalPages = Math.ceil(res.data.totalRecords / this.pageSize); //总页数
            console.log(this.totalPages,'??')
            for (var i = 0; i < res.data.data.length; i++) {
              res.data.data[i].CalendarDate = 
              new Date(res.data.data[i].CalendarDate.replace(/-/g, "/")).pattern('yyyy-MM-dd');
            }
            var _list = res.data.data;
            this.academicCalendar = [...this.academicCalendar, ..._list];
            console.log(this.academicCalendar);
            if (this.page >= this.totalPages) {
              /* 所有数据加载完毕 */
              this.listLoading = false;
              this.finished = true;
              return;
            } else {
              /* 单次请求数据完毕 */
              this.page++;
              this.listLoading = false;
            }
          } else {
            this.academicCalendar = [];
            this.listLoading = false;
          }
        }
      }
    },
    
  }
};
</script>
<style lang='less' >
#MyCalendar {
  .scrollList li {
    background: #fff;
    margin-bottom: 12px;
  }
  .box-body {
    border-bottom-color: #eee;
    padding: 24px 20px;
    h3 {
      margin-bottom: 24px;
      font-size: 32px;
      /* font-weight: 700; */
      color: #333;
    }
  }
  .box-footer {
    clear: both;
    padding: 20px;
    span {
      margin-left: 16px;
      padding: 20px 0;
    }
    .compose {
      color: #f90;
    }
  }
  .no-data-box {
    width: 74%;
    margin: 160px auto;
    text-align: center;
    font-size: 32px;
    color: #444;
    img{
      width: 100%;
    }
  }
}
</style>

